import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useCustomDialogStyles = makeStyles({
  dialogSurface: {
    position: "fixed",
    transform: "translate(-50%, -50%)",
    zIndex: 1001,
    borderRadius: "12px",
    width: "400px",
    padding: "20px",
    backgroundColor: designTokens.neutral.white,
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
  },
  dismissButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    minWidth: "32px",
    height: "32px",
  },
  dialogTitle: {
    textAlign: "center",
  },
});
